import React from 'react'
import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import configureStore from './store/configureStore'
import config from './config/config'
import { OpenTelemetryManager } from '@measurement/opentelemetry-web'

import * as serviceWorker from './serviceWorker'
import 'typeface-roboto'
import './styles/index.css'

OpenTelemetryManager.initialize({
  apiKey: config.apiKey,
  serviceName: 'cadplatformstylehub',
})

const store = configureStore()

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>,
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
